<div class="row padd-min-2">
  <label>Margin Report</label>
</div>
<div class="row">
  <div class="col-md-4 report-dropdown">
    <div class="dropdown-margin padd-min">
      <button
        class="stats-menu-btn project-type-button"
        [psUiDropdownToggleFor]="Incidence"
      >
        {{ marginReportMode }}
      </button>
      <ps-ui-dropdown class="status-dropdown" #Incidence="psUiDropdown">
        <ng-container *ngFor="let option of MARGIN_REPORT_OPTIONS">
          <button psUiDropdownItem (click)="getReport(option)">
            {{ option.label }}
          </button>
        </ng-container>
      </ps-ui-dropdown>
    </div>
  </div>
  <div
    [ngClass]="{
      'red-text': surveyMarginValue < 0 || surveyMarginPercentage < 0
    }"
    class="col-md-4 margin-report-value padd-min"
  >
    <ng-container *ngIf="marginReportMode === 'Supplier Cost'; else second">
      $ {{ surveyMarginValue }}
    </ng-container>
    <ng-template #second>
      $ {{ surveyMarginValue }} | {{ surveyMarginPercentage }} %
    </ng-template>
  </div>
</div>
